module.exports = __webpack_public_path__ + "static/media/bg.0633c450.png";